<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent" id="confetti">
        <div class="cEl" id="el1"></div>
        <div class="cEl" id="el2"></div>
        <div class="cEl" id="el3"></div>
        <div class="cEl" id="el4"></div>
        <div class="cEl" id="el5"></div>
        <div class="confetti-1"></div>
        <div class="confetti-2"></div>
        <div class="close" v-on:click="close"></div>
        <h4>Selamat <b>{{$session.get('bk6_name')}}</b></h4>
        <p>Kamu telah menyelesaikan</p>
        <img src="../assets/logo.png">
        <div class="btnCnt">
          <button class="btn report" v-on:click="openReport">Lihat Digital Report</button>
          <button class="btn finisher" v-on:click="shareFinisher">Bagikan Finisher</button>
          <button class="btn feedback" v-on:click="openTesti">Saran & Masukan</button>
        </div>
      </div>
      <Testimoni ref="testimoni"/>
      <ShareFinisher2 ref="shareFinisher2"/>
      <DigitalReport ref="digitalReport"/>
    </div>
  </transition>
</template>

<script>
import Testimoni from '@/components/Testimoni.vue';
import ShareFinisher2 from '@/components/ShareFinisher2.vue';
import DigitalReport from '@/components/DigitalReport.vue';

export default {
  name: 'confetti',
  components: { Testimoni, ShareFinisher2, DigitalReport },
  data() {
    return {
      show: false,
      next: null,
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      setTimeout(() => {
        party.confetti(document.getElementById('el1'));
        party.confetti(document.getElementById('el2'));
        party.confetti(document.getElementById('el3'));
      });
      setTimeout(() => {
        party.confetti(document.getElementById('el2'));
        party.confetti(document.getElementById('el5'));
      }, 500);
      setTimeout(() => {
        party.confetti(document.getElementById('el4'));
        party.confetti(document.getElementById('el5'));
      }, 700);
      setTimeout(() => {
        party.confetti(document.getElementById('el3'));
      }, 1000);
      setTimeout(() => {
        party.confetti(document.getElementById('el5'));
      }, 2000);
      setTimeout(() => {
        party.confetti(document.getElementById('el2'));
        party.confetti(document.getElementById('el3'));
        party.confetti(document.getElementById('el4'));
      }, 3000);
      setTimeout(() => {
        party.confetti(document.getElementById('el1'));
        party.confetti(document.getElementById('el5'));
      }, 5000);
      setTimeout(() => {
        party.confetti(document.getElementById('el2'));
      }, 6000);
      setTimeout(() => {
        party.confetti(document.getElementById('el3'));
      }, 7000);
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    openTesti() {
      this.$refs.testimoni.open();
    },
    openReport() {
      this.$refs.digitalReport.open();
    },
    shareFinisher() {
      this.$refs.shareFinisher2.open();
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      background-color: #fbffc9;
      z-index: 2;
      padding: 120px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      max-width: 460px;
      background-size: 180px auto;
      background-position: right bottom;
      background-repeat: no-repeat;
      text-align: center;
      overflow: hidden;
      .btn{
        position: relative;
        z-index: 9;
        padding: 0 16px;
        font-size: 16px;
        height: 45px;
        line-height: 45px;
        display: inline-block;
        text-decoration: none;
        margin: 0 5px 10px;
        &:hover{
          color: #fff;
        }
      }
      .cEl{
        position: absolute;
        width: 20px; height: 20px;
        &#el1{
          left: 20px; top: 20px;
        }
        &#el2{
          left: 100px; top: 100px;
        }
        &#el3{
          left: 50%; top: 50%;
        }
        &#el4{
          right: 20px; top: 50px;
        }
        &#el5{
          right: 20px; bottom: 40px;
        }
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 40px 30px 30px;
      }
      img{
        max-width: 100%;
        position: relative;
        z-index: 9;
        margin: 0 0 20px;
      }
      h4{
        margin: 0 0 2px;
        font-size: 20px;
        font-weight: 600;
        color: #00c08a;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        z-index: 3;
        text-shadow: -1px 1px 0 #dee426;
      }
      p{
        margin: 0 0 24px;
        font-size: 18px;
        text-shadow: -1px 1px 0 #dee426;
        position: relative;
        color: #00c08a;
        font-weight: 600;
        z-index: 3;
      }
      .confetti-1{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-image: url(../assets/confetti-1.png);
        background-position: top center;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .confetti-2{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-image: url(../assets/confetti-2.png);
        background-position: bottom center;
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
      .btnCnt{
        // margin: 0 -20px;
        .btn{
          position: relative;
          text-align: left;
          font-weight: 500;
          text-transform: none;
          font-size: 18px;
          padding-left: 56px;
          &:before{
            content: "";
            position: absolute;
            left: 14px; top: 0; bottom: 0; width: 30px;
            background-image: url(../assets/feedback-white.png);
            background-size: 26px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.finisher:before{
            background-image: url(../assets/finish-flag-white.png);
          }
          &.report:before{
            background-image: url(../assets/report-white.png);
          }
          @media (max-width: 680px) {
            display: block;
            width: 100%;
            margin: 0 0 10px;
          }
        }
      }
    }
  }
</style>
